import trackEvent from 'actions/analytics/trackEvent.action';

// FIXME: remove this old version and use the new one directly
const trackEventOld = (event, properties) => trackEvent({ event, properties });

// eslint-disable-next-line import/prefer-default-export
export { trackEventOld as trackEvent };
